import React from "react";
import { Form, InputGroup } from "react-bootstrap";
import { FormikProps } from "formik";
import { FormValues } from "../types";

interface SimulatorTextFieldProps {
  formik: FormikProps<FormValues>;
  name: keyof FormValues & string;
  label: React.ReactNode;
  placeholder?: string;
  /** Unidade exibida após o input (ex.: "kW", "kWh", "%"). */
  unit?: string;
  /** Prefixo exibido antes do input (ex.: "R$"). */
  prefix?: string;
  disabled?: boolean;
  required?: boolean;
  controlId?: string;
  labelStyle?: React.CSSProperties;
  onChange?: (e: React.ChangeEvent<any>) => void;
}

const groupStyle: React.CSSProperties = {
  width: "100%",
  maxWidth: "375px",
  height: "80px",
};

export const SimulatorTextField = ({
  formik,
  name,
  label,
  placeholder,
  unit,
  prefix,
  disabled,
  required,
  controlId,
  labelStyle,
  onChange,
}: SimulatorTextFieldProps) => {
  const control = (
    <Form.Control
      name={name}
      placeholder={placeholder}
      disabled={disabled}
      onChange={onChange ?? formik.handleChange}
      onBlur={formik.handleBlur}
      value={formik.values[name] as string | number}
      isInvalid={!!formik.touched[name] && !!formik.errors[name]}
      required={required}
    />
  );

  const feedback = (
    <Form.Control.Feedback type="invalid">
      {formik.errors[name] as string}
    </Form.Control.Feedback>
  );

  return (
    <Form.Group controlId={controlId ?? name} style={groupStyle}>
      <Form.Label className="simulacao-form-title" style={labelStyle}>
        {label}
      </Form.Label>
      {unit || prefix ? (
        <InputGroup className="mb-3">
          {prefix && <InputGroup.Text>{prefix}</InputGroup.Text>}
          {control}
          {unit && <InputGroup.Text>{unit}</InputGroup.Text>}
          {feedback}
        </InputGroup>
      ) : (
        <>
          {control}
          {feedback}
        </>
      )}
    </Form.Group>
  );
};
